import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("line", {
  x1: "16.5",
  y1: "9.4",
  x2: "7.5",
  y2: "4.21"
}), ___EmotionJSX("path", {
  d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
}), ___EmotionJSX("polyline", {
  points: "3.27 6.96 12 12.01 20.73 6.96"
}), ___EmotionJSX("line", {
  x1: "12",
  y1: "22.08",
  x2: "12",
  y2: "12"
}));
export default SVG;